var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{attrs:{"src":_vm.iframeSrc,"frameBorder":"0","width":"100%","height":"600px","title":"Versions"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }